import Message, { messageType as MT } from './Message';

export const messageType = MT;
export default Message;
